import { render } from "./AppFotter.vue?vue&type=template&id=70989d11&scoped=true"
const script = {}

import "./AppFotter.vue?vue&type=style&index=0&id=70989d11&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70989d11"]])

export default __exports__